import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import { getMediumAssetPath } from '@aytm/lib/common/assets'
import {
  EcommerceBannerPlacement,
  EcommerceResponse,
  IEcommerceAnswerSchema,
  IEcommerceQuestionSchema
} from '../../types.ts'
import BannerCard from './BannerCard.tsx'
import style from './Banner.module.scss'

interface IBannerProps {
  schema: IEcommerceQuestionSchema
  bannerProducts: IEcommerceAnswerSchema[]
  response: EcommerceResponse
  findability: boolean
  onItemSelect: (index: number, bannerPlacement?: EcommerceBannerPlacement) => void
  onAddToCart: (index: number, qnt: number) => void
}

const Banner = ({ schema, bannerProducts, response, findability, onItemSelect, onAddToCart }: IBannerProps) => {
  const { t } = useSurveyLocale()
  const viewport = useViewport()

  const slogan = schema.ad_company_title && <div className={style.slogan}>{schema.ad_company_title}</div>
  const sponsoredBy = schema.ad_company_description && (
    <div className={style.sponsoredBy}>{schema.ad_company_description}</div>
  )

  return (
    <section className={`${style.banner} ${viewport.mobile ? style.bannerMobile : ''}`} data-testid="SW-EC-Banner">
      <div className={style.brand}>
        {schema.ad_image1 && (
          <img src={getMediumAssetPath(schema.ad_image1)} alt="" role="presentation" className={style.logo} />
        )}
        {viewport.mobile ? (
          // The app's band shows no "Shop now" — logo beside the two text lines.
          <div className={style.brandText}>
            {slogan}
            {sponsoredBy}
          </div>
        ) : (
          <>
            {slogan}
            {sponsoredBy}
            <EmptyLink color="#0a6cff">
              <span className={style.shopNow}>{t('questions', 'ec', 'samsclub', 'bannerShopNow')}</span>
            </EmptyLink>
          </>
        )}
      </div>
      <div className={style.products}>
        {bannerProducts.map(answer => (
          <BannerCard
            key={answer.id}
            schema={schema}
            answer={answer}
            amount={response.answers[answer.index].v}
            findability={findability}
            disabled={false} // corpus rule: the banner placement sits outside the focus-mode gate (widget.md §Promo Banners)
            variant="banner"
            onSelect={() => onItemSelect(answer.index, 'banner')}
            onAdd={qnt => onAddToCart(answer.index, qnt)}
          />
        ))}
      </div>
    </section>
  )
}

export default Banner
